module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperTripleThick-ae3056132e17bef02cceb1e7ed09df82.jpg";